module.exports = __webpack_public_path__ + "img/hammer.c8f66bee.svg";